export default "__VITE_ASSET__DEQyBx4l__"